// frontend/src/pages/guides/GuideAnswer.js
// PRD-193 WP5 (193B) — the direct-answer block under every guide's H1.
//
// Answer engines extract a short, self-contained statement that answers the page's implied
// question. Before this, 0 of 19 guides opened with one: every guide led with narrative intro
// prose that reads well to a human mid-article but is useless as an extracted snippet because
// it depends on surrounding context.
//
// The text lives in guidesCatalog.js `answer`, NOT here and not inline in 22 components, so
// that it has one storage location and one length rule. `scripts/validate-guides-catalog.js`
// enforces 40-60 words on every entry; the build runs it via `postbuild`.
//
// Renders `<p className="guide-answer">` -- the class is the greppable contract PRD-193 WP5
// mandates, and it is what acceptance criterion 4 checks in the BUILT html.
//
// This sits ABOVE the existing `.guide-hero-intro` narrative rather than replacing it: the
// answer block is for extraction, the intro is for a human who has decided to read. Both earn
// their place.

import React from 'react';
import { getGuideByPath } from '../../config/guidesCatalog';

/**
 * @param {string} [path]    route path, e.g. '/guides/exposed-rdp' -- resolves `answer` from
 *                           the catalog. Preferred, and how all 22 guides call it.
 * @param {string} [answer]  explicit override, for a caller with no catalog entry.
 */
function GuideAnswer({ path, answer }) {
  const guide = path ? getGuideByPath(path) : null;
  const text = answer || (guide && guide.answer);
  // A guide whose catalog `answer` is still null (pre-WP5) renders nothing rather than an
  // empty <p>, so a partially-migrated tree never ships a hollow block.
  if (!text) return null;

  return <p className="guide-answer">{text}</p>;
}

export default GuideAnswer;
